export default __webpack_public_path__ + "0fd334c38944fb5968521b0906643f4c.png";